var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"tableTitle":_vm.tableTitle,"searchBtn":false,"form":_vm.form,"back":_vm.back,"pageFooter":true,"searchTime":false,"addHref":_vm.addHref,"detailHref":_vm.detailHref,"deleteUrl":_vm.deleteUrl,"searchUrl":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }